/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";
import {GreenTitle} from "./GreenTitle";
import {Toggle} from "./Toggle";
import {Stylable} from "@intuitionrobotics/thunderstorm/frontend";

type Props = {
	text: string
	on: boolean
	onChange: (on: boolean) => void
	stylable?: Stylable
}

export class TitleAndToggle
	extends React.Component<Props> {

	render() {
		return <div className={`ll_h_c ${this.props.stylable?.className || ''}`} style={{justifyContent: "space-between",...this.props.stylable?.style}} onClick={() => {
			this.props.onChange(!this.props.on)
		}}>
			<GreenTitle text={this.props.text}/>
			<Toggle
				on={this.props.on}
				onChange={() => {}}/>
		</div>;
	}

}
